import { Trans } from "@lingui/macro";
import { Box, useMediaQuery } from "@mui/material";
import { ThemedText } from "src/theme/text";
import styled from "styled-components";
import { ReactComponent as ReferralCode } from "src/assets/images/pid/referralCode.svg";
import { ReactComponent as ReferralLink } from "src/assets/images/pid/referralLink.svg";
import { CopyBtn } from "src/components/Button/CopyBtn";
import { useBasicInfo } from "src/hooks/useQueryDID";
import copy from "copy-to-clipboard";
import { toastSuccess } from "src/helpers/toastHelpers";
import { shorten2 } from "src/helpers";
import { useWeb3Context } from "src/hooks";

const ReferralBox = styled(Box)`
  border: 1px solid #22d758;
  background: #003410;
  border-radius: 8px;
  .title {
    height: 40px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);
  }
  .referralItem {
    min-height: 76px;
    padding: 25px 22px 25px 22px;
    flex: 1;
  }
  @media only screen and (max-width: 1280px) {
  }
`;

export default function Referral() {
  const isSmallScreen = useMediaQuery("(max-width: 1280px)");
  const isVerySmallScreen = useMediaQuery("(max-width: 768px)");
  const baseInfo = useBasicInfo();
  const { chainID } = useWeb3Context();

  return (
    <ReferralBox className="referral-view">
      <div className="title">
        <ThemedText.Text1 fontSize={14} ml="20px">
          <Trans>Referral</Trans>
        </ThemedText.Text1>
      </div>
      <Box
        display="flex"
        alignItems={isVerySmallScreen ? "flex-start" : "center"}
        gap="24px"
        flexDirection={isVerySmallScreen ? "column" : "row"}
      >
        <Box
          display="flex"
          flexDirection={isVerySmallScreen ? "column" : "row"}
          justifyContent="space-between"
          alignItems={isVerySmallScreen ? "flex-start" : "center"}
          className="referralItem"
          gap="8px"
        >
          <Box display="flex" alignItems="center">
            <ReferralCode />
            <ThemedText.Text1Bold fontSize={18} ml="12px">
              <Trans>Code</Trans>
            </ThemedText.Text1Bold>
          </Box>
          <Box display="flex" alignItems="center">
            <ThemedText.Text2 mr="16px">
              {baseInfo?.refCode ? baseInfo?.refCode : "--"}
            </ThemedText.Text2>
            <CopyBtn
              onClick={() => {
                copy(baseInfo?.refCode), toastSuccess("copy success");
              }}
            >
              Copy
            </CopyBtn>
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection={isVerySmallScreen ? "column" : "row"}
          justifyContent="space-between"
          alignItems={isVerySmallScreen ? "flex-start" : "center"}
          className="referralItem"
          gap="8px"
        >
          <Box display="flex" alignItems="center">
            <ReferralLink />
            <ThemedText.Text1Bold fontSize={18} ml="12px">
              <Trans>Link</Trans>
            </ThemedText.Text1Bold>
          </Box>
          <Box display="flex" alignItems="center">
            <ThemedText.Text2 mr="16px">
              {shorten2(
                `https://app.dyna.finance/#/DARMY?ref=${baseInfo?.refCode}`,
                chainID
              )}
            </ThemedText.Text2>
            <CopyBtn
              onClick={() => {
                copy(
                  `https://app.dyna.finance/#/DARMY?ref=${baseInfo?.refCode}`
                ),
                  toastSuccess("copy success");
              }}
            >
              Copy
            </CopyBtn>
          </Box>
        </Box>
      </Box>
    </ReferralBox>
  );
}
